<div class="container" *ngLet="catalogs$ | async">
  <div class="first-row" *ngLet="filterForm$ | async">
    <span class="h2-impaired">
      {{ 'DATA.TABLE_FILTER.TOTAL' | translate }} {{ catalogCount }}
      {{ catalogCount | dw: 'DATA.TABLE_FILTER.SET':'DATA.TABLE_FILTER.SET_GENITIVE':'DATA.TABLE_FILTER.SETS' | translate }}
    </span>
    <app-button-icon
      cdkOverlayOrigin
      #filterTrigger="cdkOverlayOrigin"
      (clickOnButton)="isOpenFilter = !isOpenFilter"
      [buttonName]="'VERSION_VISUALLY_IMPAIRED.FILTER_BY_DATASET' | translate"
    ></app-button-icon>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayPositions]="filterOverlayPosition"

      [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
      [cdkConnectedOverlayOrigin]="filterTrigger"
      [cdkConnectedOverlayOpen]="isOpenFilter"
      (backdropClick)="isOpenFilter = !isOpenFilter"
      [cdkConnectedOverlayPanelClass]="'cdk-version-for-visually-impaired'"

    >
      <app-filter-table-dialog (close)="isOpenFilter = false"></app-filter-table-dialog>
    </ng-template>
    <app-button-icon
      (clickOnButton)="clearFilter()"
      [isButtonDisabled]="!hasFilter"
      [iconName]="icons.Close"
      [buttonName]="'VERSION_VISUALLY_IMPAIRED.RESET_FILTERS' | translate"
    ></app-button-icon>
  </div>

  <div class="row mt24" *ngLet="sortingDataSet$ | async">
    <div #categoriesButton class="row-filter">
      <app-multi-select
        #categoriesSelect
        *ngLet="(categoriesList$ | async)"
        [isVersionImpaired]="true"
        [dropdownWidth]="categoriesButton.offsetWidth - 2"
        [options]="(categories$ | async) ?? []"
        (choose)="onChooseCategories($event)"
        [overlayPosition]="dropDownOverlayPosition"
        (isOpenDropDownChanged)="isActiveCategoryFilter = $event"
      >
        <div class="center">
          <app-button-icon
            [iconName]="isActiveCategoryFilter ? icons.Close : icons.BigTriangleDown"
            [isActive]="isActiveCategoryFilter"
            [classSize]="'big-impaired'"
            buttonName="{{ 'DATA.TABLE_FILTER.CATEGORIES' | translate }} : {{ countSelectCategories }}"
          ></app-button-icon>
        </div>
      </app-multi-select>
    </div>

    <div #providersButton class="row-filter">
      <app-multi-select
        *ngLet="(providersList$ | async)"
        #providerSelect
        [isVersionImpaired]="true"
        [dropdownWidth]="providersButton.offsetWidth - 2"
        [options]=" (providers$ | async) ?? []"
        (choose)="onChooseProviders($event)"
        [overlayPosition]="dropDownOverlayPosition"
        (isOpenDropDownChanged)="isActiveProviderFilter = $event"
      >
        <div class="center">
          <app-button-icon
            [iconName]="isActiveProviderFilter ? icons.Close : icons.BigTriangleDown"
            [isActive]="isActiveProviderFilter"
            [classSize]="'big-impaired'"
            buttonName="{{ 'DATA.TABLE_FILTER.SUPPLIERS' | translate }}: {{ countSelectProviders }}"
          ></app-button-icon>
        </div>
      </app-multi-select>
    </div>
  </div>
</div>
